<template>
  <div class="main-content">
    <!-- 检索过滤区域 -->
    <div class="search-wrapper marginBottom20">
      <el-form :inline="true" :model="searchData" class="demo-form-inline">
        <!-- 任务名称 -->
        <el-form-item label="任务名称 :">
          <el-input
            v-model="searchData.name"
            placeholder="请输入任务名称"
            clearable
            maxlength="100"
            style="width: 220px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>

        <!-- 权益等级 -->
        <el-form-item label="权益等级 :">
          <el-select
            v-model="searchData.equityClassifyId"
            placeholder="全部等级"
            clearable
            style="width: 200px"
          >
            <el-option
              v-for="item in equityOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 上架状态 -->
        <el-form-item label="上架状态 :">
          <el-select
            v-model="searchData.state"
            placeholder="全部状态"
            clearable
            style="width: 180px"
          >
            <el-option label="上架" :value="1"></el-option>
            <el-option label="下架" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <!-- 按钮区 -->
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearch"
            >查询</el-button
          >
          <el-button size="medium" icon="el-icon-refresh" @click="handleReset"
            >重置</el-button
          >
          <el-button
            size="medium"
            type="primary"
            icon="el-icon-plus"
            @click="handleCreate"
          >
            新增学习任务
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据列表表格 -->
    <div class="table-container">
      <el-table
        v-loading="showLoading"
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{
          background: '#f8f9fa',
          color: '#333333',
          fontWeight: 'bold',
          fontSize: '14px',
          height: '48px',
        }"
      >
        <!-- 任务名称 -->
        <el-table-column
          prop="name"
          label="任务名称"
          min-width="200"
          header-align="center"
          align="center"
        >
          <template slot-scope="{ row }">
            <span class="task-name">{{ row.name }}</span>
          </template>
        </el-table-column>

        <!-- 关联权益分类 -->
        <el-table-column
          prop="equityClassifyName"
          label="关联权益分类"
          min-width="180"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ row.equityClassifyName || "—" }}</span>
          </template>
        </el-table-column>

        <!-- 关联课程 -->
        <el-table-column
          label="关联课程"
          min-width="250"
          header-align="center"
          align="center"
        >
          <template slot-scope="{ row }">
            <div class="associated-courses">
              {{ row.courseNames || "-" }}
            </div>
          </template>
        </el-table-column>

        <!-- 上架状态 -->
        <el-table-column label="上架状态" width="110" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.state"
              :active-value="1"
              :inactive-value="2"
              @change="handleStateChange(row)"
            ></el-switch>
          </template>
        </el-table-column>

        <!-- 创建时间 -->
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="180"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ formatTime(row.createTime) }}</span>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              class="action-btn btn-edit"
              @click="handleEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              class="action-btn btn-delete"
              @click="handleDelete(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-container marginTop20 flex justify-end">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      >
      </el-pagination>
    </div>

    <!-- 新增/修改弹窗 -->
    <el-dialog
      v-if="dialogVisible"
      :title="form.id ? '编辑学习任务' : '新增学习任务'"
      :visible.sync="dialogVisible"
      width="680px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="task-dialog"
    >
      <el-form
        ref="formRef"
        :model="form"
        :rules="formRules"
        label-width="110px"
        size="medium"
        style="padding: 0 10px"
      >
        <!-- 任务名称 -->
        <el-form-item label="任务名称" prop="name">
          <el-input
            v-model="form.name"
            maxlength="100"
            placeholder="请输入任务名称"
            clearable
            show-word-limit
          ></el-input>
        </el-form-item>

        <!-- 关联权益分类 -->
        <el-form-item label="权益分类" prop="selectedEquityIds">
          <el-select
            v-model="form.selectedEquityIds"
            multiple
            placeholder="请选择权益分类"
            style="width: 100%"
          >
            <el-option
              v-for="item in equityOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 上架状态 -->
        <el-form-item label="上架状态" prop="state">
          <el-radio-group v-model="form.state">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="2">下架</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 关联内容配置 -->
        <div class="content-编排-container">
          <div class="编排-header flex justify-between align-center">
            <span class="编排-title"
              >关联任务内容 <span class="required-star">*</span></span
            >
            <div class="flex">
              <el-button
                type="success"
                size="mini"
                icon="el-icon-plus"
                @click="handleOpenAddCourse"
                >关联课程</el-button
              >
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-plus"
                @click="handleOpenAddPackage"
                style="margin-left: 10px"
                >关联课程包</el-button
              >
            </div>
          </div>

          <!-- 已添加的内容列表表格 -->
          <el-table
            :data="form.itemList"
            border
            size="small"
            style="width: 100%; margin-top: 10px"
            empty-text="暂无关联的课程或课程包，请点击上方按钮进行关联配课"
          >
            <el-table-column label="类型" width="110" align="center">
              <template slot-scope="{ row }">
                <el-tag
                  size="mini"
                  :type="row.type === 1 ? 'success' : 'warning'"
                >
                  {{ row.type === 1 ? "课程" : "课程包" }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="内容名称"
              min-width="240"
              header-align="center"
              align="left"
            >
              <template slot-scope="{ row }">
                <span>{{ getItemTitle(row) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="{ row, $index }">
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  class="btn-delete-item"
                  @click="removeItem($index)"
                  >移除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>

      <!-- 弹窗底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="medium">取 消</el-button>
        <el-button
          type="primary"
          @click="submit"
          :loading="showLoadingForm"
          size="medium"
          class="btn-submit"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>

    <!-- 选择关联课程的多选 Dialog -->
    <el-dialog
      title="选择关联课程"
      :visible.sync="courseDialogVisible"
      width="780px"
      append-to-body
      class="course-select-dialog"
      @opened="onCourseDialogOpened"
    >
      <div class="dialog-search marginBottom15 flex align-center">
        <el-input
          v-model="courseSearchQuery"
          placeholder="搜索课程标题"
          size="small"
          prefix-icon="el-icon-search"
          clearable
          style="width: 240px; margin-right: 10px"
          @keyup.enter.native="handleDialogCourseSearch"
          @clear="handleDialogCourseSearch"
        ></el-input>
        <el-select
          v-model="courseEquityClassifyId"
          placeholder="全部权益等级"
          size="small"
          clearable
          style="width: 160px; margin-right: 10px"
          @change="handleDialogCourseSearch"
          @clear="handleDialogCourseSearch"
        >
          <el-option
            v-for="item in equityOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="handleDialogCourseSearch"
          >查询</el-button
        >
      </div>

      <el-table
        ref="courseTable"
        v-loading="dialogCourseLoading"
        :data="dialogCourseList"
        row-key="id"
        border
        size="small"
        height="350px"
        style="width: 100%"
        @selection-change="handleCourseSelectionChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          label="课程标题"
          prop="title"
          min-width="220"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column label="分类" width="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.classifyName || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="权益等级" width="140" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.equityClassName || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上架状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.state === 1" type="success" size="mini"
              >已上架</el-tag
            >
            <el-tag v-else-if="row.state === 2" type="danger" size="mini"
              >已下架</el-tag
            >
            <span v-else>—</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        @size-change="handleDialogCourseSizeChange"
        @current-change="handleDialogCourseCurrentChange"
        :current-page="dialogCoursePage.current"
        :page-sizes="[10, 20, 50]"
        :page-size="dialogCoursePage.size"
        layout="total, sizes, prev, pager, next"
        :total="dialogCoursePage.total"
        style="margin-top: 15px; text-align: right"
      >
      </el-pagination>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="courseDialogVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="confirmAddCourses"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 选择关联课程包的多选 Dialog -->
    <el-dialog
      title="选择关联课程包"
      :visible.sync="packageDialogVisible"
      width="700px"
      append-to-body
      class="package-select-dialog"
      @opened="onPackageDialogOpened"
    >
      <div class="dialog-search marginBottom15 flex align-center">
        <el-input
          v-model="packageSearchQuery"
          placeholder="搜索课程包标题"
          size="small"
          prefix-icon="el-icon-search"
          clearable
          style="width: 320px; margin-right: 10px"
          @keyup.enter.native="handleDialogPackageSearch"
          @clear="handleDialogPackageSearch"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="handleDialogPackageSearch"
          >查询</el-button
        >
      </div>

      <el-table
        ref="packageTable"
        v-loading="dialogPackageLoading"
        :data="dialogPackageList"
        row-key="id"
        border
        size="small"
        height="350px"
        style="width: 100%"
        @selection-change="handlePackageSelectionChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          label="课程包标题"
          prop="title"
          min-width="220"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column label="分类" width="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.classifyName || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上架状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.state === 1" type="success" size="mini"
              >已上架</el-tag
            >
            <el-tag v-else-if="row.state === 2" type="danger" size="mini"
              >已下架</el-tag
            >
            <span v-else>—</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        @size-change="handleDialogPackageSizeChange"
        @current-change="handleDialogPackageCurrentChange"
        :current-page="dialogPackagePage.current"
        :page-sizes="[10, 20, 50]"
        :page-size="dialogPackagePage.size"
        layout="total, sizes, prev, pager, next"
        :total="dialogPackagePage.total"
        style="margin-top: 15px; text-align: right"
      >
      </el-pagination>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="packageDialogVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="confirmAddPackages"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  studyTaskList,
  studyTaskAdd,
  studyTaskUpdate,
  studyTaskDelete,
  studyTaskStateUpdate,
  studyTaskDetail,
} from "@/api/course/studyTask";
import { equityListClassify } from "@/api/equity/manage";
import { courseInfoListAll, courseInfoList } from "@/api/course/info";
import { coursePackageListAll, coursePackageList } from "@/api/course/package";

export default {
  name: "StudyTask",
  data() {
    return {
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      courseDialogVisible: false,
      packageDialogVisible: false,
      searchData: {
        name: "",
        equityClassifyId: "",
        state: "",
      },
      equityOptions: [], // 权益分类列表
      allCoursesList: [], // 所有课程列表
      allPackagesList: [], // 所有课程包列表
      courseMap: {}, // 课程缓存Map
      packageMap: {}, // 课程包缓存Map
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      form: {
        id: "",
        name: "",
        state: 1,
        equityClassifyIds: "",
        equityClassifyName: "",
        itemList: [],
        selectedEquityIds: [], // 弹窗表单中已选权益ID数组
      },
      formRules: {
        name: [
          { required: true, message: "请输入学习任务名称", trigger: "blur" },
          { max: 100, message: "任务名称不能超过 100 个字符", trigger: "blur" },
        ],
        selectedEquityIds: [
          {
            required: true,
            type: "array",
            message: "请选择权益分类",
            trigger: "change",
          },
        ],
        state: [
          { required: true, message: "请选择上架状态", trigger: "change" },
        ],
      },
      courseSearchQuery: "",
      courseEquityClassifyId: "",
      packageSearchQuery: "",
      tempSelectedCourses: [], // 课程临时选择
      tempSelectedPackages: [], // 课程包临时选择
      isLayoutSelection: false, // 正在程序化回显课程勾选，用于拦截 selection-change 的清空副作用
      isLayoutPackageSelection: false, // 正在程序化回显课程包勾选，用于拦截 selection-change 的清空副作用
      dialogCourseList: [], // 弹窗可选课程列表
      dialogCoursePage: {
        current: 1,
        size: 10,
        total: 0,
      },
      dialogCourseLoading: false,
      dialogPackageList: [], // 弹窗可选课程包列表
      dialogPackagePage: {
        current: 1,
        size: 10,
        total: 0,
      },
      dialogPackageLoading: false,
    };
  },

  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      this.showLoading = true;
      try {
        await Promise.all([
          this.getEquityOptions(),
          this.getAllCoursesList(),
          this.getAllPackagesList(),
        ]);
        this.onLoad();
      } catch (e) {
        console.error(e);
        this.showLoading = false;
      }
    },

    // 获取所有权益分类
    async getEquityOptions() {
      const res = await equityListClassify();
      if (res.code === 200 && res.data) {
        this.equityOptions = res.data.records || res.data || [];
      }
    },

    // 获取全部课程
    async getAllCoursesList() {
      const res = await courseInfoListAll();
      if (res.code === 200 && Array.isArray(res.data)) {
        this.allCoursesList = res.data;
        const map = {};
        res.data.forEach((item) => {
          map[item.id] = item;
        });
        this.courseMap = map;
      }
    },

    // 获取全部课程包
    async getAllPackagesList() {
      const res = await coursePackageListAll();
      if (res.code === 200 && Array.isArray(res.data)) {
        this.allPackagesList = res.data;
        const map = {};
        res.data.forEach((item) => {
          map[item.id] = item;
        });
        this.packageMap = map;
      }
    },

    // 加载列表数据
    onLoad() {
      this.showLoading = true;
      const params = {
        name: this.searchData.name ? this.searchData.name.trim() : undefined,
        equityClassifyId: this.searchData.equityClassifyId || undefined,
        state: this.searchData.state || undefined,
        page: this.page.current,
        size: this.page.size,
      };
      studyTaskList(params)
        .then((res) => {
          this.showLoading = false;
          if (res.code === 200 && res.data) {
            this.tableData = res.data.records || [];
            this.page.total = Number(res.data.total) || 0;
          }
        })
        .catch(() => {
          this.showLoading = false;
        });
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return "—";
      try {
        const date = new Date(time);
        if (isNaN(date.getTime())) return time;
        const pad = (num) => String(num).padStart(2, "0");
        const y = date.getFullYear();
        const m = pad(date.getMonth() + 1);
        const d = pad(date.getDate());
        const h = pad(date.getHours());
        const min = pad(date.getMinutes());
        return `${y}-${m}-${d} ${h}:${min}`;
      } catch (e) {
        return time;
      }
    },

    // 查询
    handleSearch() {
      this.page.current = 1;
      this.onLoad();
    },

    // 重置
    handleReset() {
      this.searchData.name = "";
      this.searchData.equityClassifyId = "";
      this.searchData.state = "";
      this.page.current = 1;
      this.onLoad();
    },

    // 每页条数切换
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.onLoad();
    },

    // 页码切换
    handleCurrentChange(val) {
      this.page.current = val;
      this.onLoad();
    },

    // 快捷上架/下架
    handleStateChange(row) {
      const originalState = row.state === 1 ? 2 : 1;
      const stateText = row.state === 1 ? "上架" : "下架";

      studyTaskStateUpdate({
        id: row.id,
        state: row.state,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(
              `已成功将学习任务【${row.name}】${stateText}`
            );
            this.onLoad();
          } else {
            row.state = originalState;
          }
        })
        .catch(() => {
          row.state = originalState;
        });
    },

    // 翻译显示名称
    getItemTitle(item) {
      if (item.type === 1) {
        const c = this.courseMap[item.refId];
        return c ? c.title : "未知课程";
      } else {
        const p = this.packageMap[item.refId];
        return p ? p.title : "未知课程包";
      }
    },

    // 移除已关联项
    removeItem(index) {
      this.form.itemList.splice(index, 1);
    },

    /**
     * 监听选择课程 Dialog 完全打开的事件，确保在 DOM 渲染就绪后执行勾选回显
     */
    onCourseDialogOpened() {
      this.$nextTick(() => {
        this.initCourseTableSelection();
      });
    },

    /**
     * 初始化课程表格勾选回显。在更新选择状态时通过标志位屏蔽事件副作用，同时优先选择表格中的真实行对象进行勾选。
     */
    initCourseTableSelection() {
      if (this.$refs.courseTable) {
        this.isLayoutSelection = true;
        const backup = [...this.tempSelectedCourses];

        // 清空状态
        this.$refs.courseTable.clearSelection();
        backup.forEach((row) => {
          const matchRow = this.dialogCourseList.find(
            (item) => item.id === row.id
          );
          if (matchRow) {
            this.$refs.courseTable.toggleRowSelection(matchRow, true);
          } else {
            this.$refs.courseTable.toggleRowSelection(row, true);
          }
        });

        this.tempSelectedCourses = backup;

        this.$nextTick(() => {
          this.isLayoutSelection = false;
        });
      }
    },

    /**
     * 监听选择课程包 Dialog 完全打开的事件，确保在 DOM 渲染就绪后执行勾选回显
     */
    onPackageDialogOpened() {
      this.$nextTick(() => {
        this.initPackageTableSelection();
      });
    },

    /**
     * 初始化课程包表格勾选回显。在更新选择状态时通过标志位屏蔽事件副作用，同时优先选择表格中的真实行对象进行勾选。
     */
    initPackageTableSelection() {
      if (this.$refs.packageTable) {
        this.isLayoutPackageSelection = true;
        const backup = [...this.tempSelectedPackages];

        // 清空状态
        this.$refs.packageTable.clearSelection();
        backup.forEach((row) => {
          const matchRow = this.dialogPackageList.find(
            (item) => item.id === row.id
          );
          if (matchRow) {
            this.$refs.packageTable.toggleRowSelection(matchRow, true);
          } else {
            this.$refs.packageTable.toggleRowSelection(row, true);
          }
        });

        this.tempSelectedPackages = backup;

        this.$nextTick(() => {
          this.isLayoutPackageSelection = false;
        });
      }
    },

    /**
     * 打开课程关联弹窗并初始化已选数据
     */
    async handleOpenAddCourse() {
      this.courseSearchQuery = "";
      this.courseEquityClassifyId = "";
      this.dialogCoursePage.current = 1;
      this.dialogCoursePage.size = 10;
      this.dialogCourseList = [];

      // 初始化当前已绑定的课程数据到临时已选列表中
      const selectedCourseIds = this.form.itemList
        .filter((i) => i.type === 1)
        .map((i) => i.refId);
      this.tempSelectedCourses = selectedCourseIds
        .map((id) => this.courseMap[id])
        .filter(Boolean);

      this.courseDialogVisible = true;

      await this.getDialogCourseList();

      this.$nextTick(() => {
        this.initCourseTableSelection();
      });
    },

    /**
     * 分页查询弹窗中的课程列表
     */
    async getDialogCourseList() {
      this.dialogCourseLoading = true;
      try {
        const params = {
          title: this.courseSearchQuery
            ? this.courseSearchQuery.trim()
            : undefined,
          equityClassifyId: this.courseEquityClassifyId || undefined,
          state: 1, // 只查询已上架的课程
          page: this.dialogCoursePage.current,
          size: this.dialogCoursePage.size,
        };
        const res = await courseInfoList(params);
        if (res.code === 200 && res.data) {
          this.dialogCourseList = res.data.records || [];
          this.dialogCoursePage.total = Number(res.data.total) || 0;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.dialogCourseLoading = false;
      }
    },

    /**
     * 弹窗内根据关键词搜索课程
     */
    handleDialogCourseSearch() {
      this.dialogCoursePage.current = 1;
      this.getDialogCourseList();
    },

    /**
     * 弹窗内课程表格分页大小变更
     * @param {number} val - 每页条数
     */
    handleDialogCourseSizeChange(val) {
      this.dialogCoursePage.size = val;
      this.dialogCoursePage.current = 1;
      this.getDialogCourseList();
    },

    /**
     * 弹窗内课程表格分页页码切换
     * @param {number} val - 当前页码
     */
    handleDialogCourseCurrentChange(val) {
      this.dialogCoursePage.current = val;
      this.getDialogCourseList();
    },

    /**
     * 响应课程选择变更
     * @param {Array} val - 当前表格中所有选中的课程行对象数组
     */
    handleCourseSelectionChange(val) {
      if (this.isLayoutSelection) return;
      this.tempSelectedCourses = val;
    },

    /**
     * 确认并保存当前已勾选的关联课程到表单列表
     */
    confirmAddCourses() {
      const packageList = this.form.itemList.filter((i) => i.type === 2);
      const newCourseList = this.tempSelectedCourses.map((course) => ({
        id: "",
        refId: course.id,
        type: 1,
      }));
      this.form.itemList = [...newCourseList, ...packageList];
      this.courseDialogVisible = false;
    },

    /**
     * 打开课程包关联弹窗并初始化已选数据
     */
    async handleOpenAddPackage() {
      this.packageSearchQuery = "";
      this.dialogPackagePage.current = 1;
      this.dialogPackagePage.size = 10;
      this.dialogPackageList = [];

      // 初始化当前已绑定的课程包数据到临时已选列表中
      const selectedPackageIds = this.form.itemList
        .filter((i) => i.type === 2)
        .map((i) => i.refId);
      this.tempSelectedPackages = selectedPackageIds
        .map((id) => this.packageMap[id])
        .filter(Boolean);

      this.packageDialogVisible = true;

      await this.getDialogPackageList();

      this.$nextTick(() => {
        this.initPackageTableSelection();
      });
    },

    // 分页获取弹窗课程包列表
    async getDialogPackageList() {
      this.dialogPackageLoading = true;
      try {
        const params = {
          title: this.packageSearchQuery
            ? this.packageSearchQuery.trim()
            : undefined,
          state: 1, // 只查询已上架的课程包
          page: this.dialogPackagePage.current,
          size: this.dialogPackagePage.size,
        };
        const res = await coursePackageList(params);
        if (res.code === 200 && res.data) {
          this.dialogPackageList = res.data.records || [];
          this.dialogPackagePage.total = Number(res.data.total) || 0;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.dialogPackageLoading = false;
      }
    },

    // 弹窗课程包搜索
    handleDialogPackageSearch() {
      this.dialogPackagePage.current = 1;
      this.getDialogPackageList();
    },

    // 弹窗课程包分页条数切换
    handleDialogPackageSizeChange(val) {
      this.dialogPackagePage.size = val;
      this.dialogPackagePage.current = 1;
      this.getDialogPackageList();
    },

    // 弹窗课程包分页页码切换
    handleDialogPackageCurrentChange(val) {
      this.dialogPackagePage.current = val;
      this.getDialogPackageList();
    },

    /**
     * 响应课程包选择变更
     * @param {Array} val - 当前表格中所有选中的课程包行对象数组
     */
    handlePackageSelectionChange(val) {
      if (this.isLayoutPackageSelection) return;
      this.tempSelectedPackages = val;
    },

    // 确定添加课程包
    confirmAddPackages() {
      // 提取目前 itemList 里的所有“课程”
      const courseList = this.form.itemList.filter((i) => i.type === 1);
      // 构造新勾选的课程包
      const newPackageList = this.tempSelectedPackages.map((pkg) => ({
        id: "",
        refId: pkg.id,
        type: 2,
      }));
      // 合并写入
      this.form.itemList = [...courseList, ...newPackageList];
      this.packageDialogVisible = false;
    },

    // 新增任务点击
    handleCreate() {
      this.form = {
        id: "",
        name: "",
        state: 1,
        equityClassifyIds: "",
        equityClassifyName: "",
        itemList: [],
        selectedEquityIds: [],
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    /**
     * 编辑按钮点击事件，调用详情接口获取单条学习任务详情并执行表单回显
     * @param {Object} row - 当前点击行对应的表格学习任务数据对象
     */
    async handleEdit(row) {
      this.showLoading = true;
      try {
        const res = await studyTaskDetail(row.id);
        this.showLoading = false;
        if (res.code === 200 && res.data) {
          const detail = res.data;
          this.form = {
            id: detail.id,
            name: detail.name,
            state: detail.state || 1,
            equityClassifyIds: detail.equityClassifyIds || "",
            equityClassifyName: detail.equityClassifyName || "",
            itemList: Array.isArray(detail.itemList)
              ? detail.itemList.map((item) => ({
                  id: item.id || "",
                  refId: item.refId,
                  type: item.type,
                }))
              : [],
            selectedEquityIds: detail.equityClassifyIds
              ? detail.equityClassifyIds.split(",")
              : [],
          };
          this.dialogVisible = true;
          this.$nextTick(() => {
            if (this.$refs.formRef) {
              this.$refs.formRef.clearValidate();
            }
          });
        } else {
          this.$message.error(res.msg || "未找到学习任务数据");
        }
      } catch (e) {
        console.error(e);
        this.showLoading = false;
      }
    },

    // 删除
    handleDelete(row) {
      this.$confirm(`确定要永久删除学习任务【${row.name}】吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          studyTaskDelete(row.id).then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功!");
              this.onLoad();
            }
          });
        })
        .catch(() => {});
    },

    // 关闭大对话框
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        id: "",
        name: "",
        state: 1,
        equityClassifyIds: "",
        equityClassifyName: "",
        itemList: [],
        selectedEquityIds: [],
      };
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate();
      }
    },

    // 提交保存
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.form.itemList.length === 0) {
            this.$message.warning("请添加至少一个关联课程或课程包");
            return;
          }

          if (this.showLoadingForm) return;
          this.showLoadingForm = true;

          // 整理多选权益分类的数据
          const foundNames = [];
          this.form.selectedEquityIds.forEach((id) => {
            const found = this.equityOptions.find((item) => item.id === id);
            if (found) {
              foundNames.push(found.name);
            }
          });

          const submitData = {
            ...this.form,
            name: this.form.name.trim(),
            equityClassifyIds: this.form.selectedEquityIds.join(","),
            equityClassifyName: foundNames.join(","),
          };

          const requestApi = submitData.id ? studyTaskUpdate : studyTaskAdd;

          requestApi(submitData)
            .then((res) => {
              this.showLoadingForm = false;
              if (res.code === 200) {
                this.$message.success("操作成功");
                this.dialogVisible = false;
                this.onLoad();
              }
            })
            .catch(() => {
              this.showLoadingForm = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.main-content {
  padding: 20px;
  background-color: #ffffff;
  min-height: calc(100vh - 100px);
}

.action-bar {
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
}

.page-title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.table-container {
  margin-top: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
}

.task-name {
  font-weight: 500;
  color: #333333;
}

/* 操作按钮 */
.action-btn {
  font-weight: 500;
  font-size: 14px;
  margin: 0 10px;
  padding: 0;
  border: none;
}

.btn-delete {
  color: #ff001f !important;
}
.btn-delete:hover {
  color: #cc0018 !important;
  text-decoration: underline;
}

.btn-delete-item {
  color: #f56c6c !important;
}

/* 内容编排 */
.content-编排-container {
  margin-top: 20px;
  border-top: 1px dashed #dcdfe6;
  padding-top: 20px;
}

.编排-header {
  margin-bottom: 10px;
}

.编排-title {
  font-size: 15px;
  font-weight: bold;
  color: #333333;
}

.required-star {
  color: #f56c6c;
  margin-left: 4px;
}

/* 间距辅助 */
.marginBottom15 {
  margin-bottom: 15px;
}
.marginBottom20 {
  margin-bottom: 20px;
}
.marginTop20 {
  margin-top: 20px;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.justify-end {
  justify-content: flex-end;
}
.align-center {
  align-items: center;
}
</style>